import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import {
  CogIcon,
  LightBulbIcon,
  PresentationChartLineIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';

const ITConsulting = () => {
  const serviceData = {
    icon: CogIcon,
    title: 'IT Consulting',
    description: 'Strategic IT guidance to help your business leverage technology effectively and make informed decisions about your digital infrastructure and transformation.',
    gradient: 'from-green-800 to-green-900',
    technologies: [
      'Cloud Platforms',
      'Enterprise Software',
      'Business Intelligence',
      'System Integration',
      'Security Solutions',
      'DevOps Tools',
    ],
    features: [
      {
        icon: LightBulbIcon,
        title: 'Strategic Planning',
        description: 'Comprehensive technology strategy aligned with business goals.',
      },
      {
        icon: PresentationChartLineIcon,
        title: 'Process Analysis',
        description: 'Analyzing current processes to identify optimization opportunities.',
      },
      {
        icon: ShieldCheckIcon,
        title: 'Risk Assessment',
        description: 'Identifying and mitigating technology risks and vulnerabilities.',
      },
    ],
    services: [
      'IT Strategy Development',
      'Technology Assessment',
      'Digital Transformation',
      'System Architecture Design',
      'Vendor Selection & Management',
      'Security Consulting',
      'Process Optimization',
      'Training & Support',
    ],
    whyChoose: [
      'Industry Expertise & Best Practices',
      'Tailored Solutions for Your Business',
      'Cost-Effective Technology Strategies',
      'Ongoing Support & Guidance',
    ],
  };

  return <ServiceTemplate {...serviceData} />;
};

export default ITConsulting;
